import { generateSeoProps } from '../generateSeoProps';

export const getCareerPathProps = () => {
    return generateSeoProps({
        title: 'Pharmuni Career Paths: Become an Expert with Role-Based Learning',
        canonical: 'career-path',
        noIndex: false,
        description: `Browse curated GMP, QA & project-manager paths. Follow step-by-step courses, earn certificates and grow into your next pharma role`,
    });
};

export const getCareerPathDynamicProps = ({ title = '', description = '', id = '', slug = '', image = '' }) => {
    return generateSeoProps({
        title: `${title} - Pharmuni Career Path`,
        description: description,
        canonical: `career-path/${id}/${slug}`,
        noIndex: false,
        image: image
    });
};